import moment from 'moment'

export const getShiftDurationAsMinutes = (start: string, end: string) => {
  const dateEnd = moment(end, 'HH:mm')
  const dateStart = moment(start, 'HH:mm')

  if (dateStart.isBefore(dateEnd)) {
    return moment.duration(dateEnd.diff(dateStart)).asMinutes()
  }

  dateEnd.add(1, 'day')
  return moment.duration(dateEnd.diff(dateStart)).asMinutes()
}
